<template>
    <div class="mt-4">
        <div>
            <span class="text-lg font-semibold">
                {{ $moment(data.created).format('HH:mm DD MMMM YYYY') }}
            </span>
        </div>
        <div class="ml-4 text-lg mb-4">
            {{ data.text }}
        </div>
        <div class="ml-4">
            <div class="flex flex-col md:flex-row justify-start items-center md:items-start mb-8"
                 v-for="file in data.files" :key="file.uid">
                <div class="mr-4">
                    <img :src="file['content_type'].indexOf('image') > -1 ? file.path : require('@/assets/images/icon_file.jpg')"
                         alt=""
                         class="custom-attach-image rounded shadow-md">
                </div>
                <div class="flex flex-col w-full ">
                    <span class="text-base mb-4" style="word-wrap: break-word;">{{ file.name }}</span>
                    <div class="flex flex-col w-full md:flex-row">
                        <a :href="file.path"
                           target="_blank">
                            <vs-button color="warning"
                                       v-if="file['content_type'].indexOf('image') > -1 || file['content_type'].indexOf('pdf')> -1"
                                       type="relief"
                                       class="mr-0 md:mr-4 w-full md:w-auto mb-2 md:mb-0">
                                {{ $t('open_in_new_tab') }}
                            </vs-button>
                        </a>
                        <a :href="file.path" download>
                            <vs-button type="relief"
                                       class="w-full md:w-auto">
                                {{ $t('download') }}
                            </vs-button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BlockComment",
    props: {
        data: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
.custom-attach-image{
    width: 150px;
    height: 150px;
    object-fit: cover;
}
</style>
